/*Detecta si es un dispositivo movil o no...*/
const body = document.querySelector("body");
function detectarDispositivo() {
  const userAgent = navigator.userAgent;
  const anchoPantalla = window.innerWidth;
  const esCelular = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) || anchoPantalla < 768;
  if (esCelular) {
    document.body.classList.add('data-browser-cel');
  } else {
    document.body.classList.add('data-browser-pc');
  }
}
// Ejecutar la función al cargar la página
document.addEventListener('DOMContentLoaded', detectarDispositivo);
ready = () => {
  const insertarRayaEnTitulos1 = document.querySelector('.lujo-que-mereces .m-section__header h2');
  if (insertarRayaEnTitulos1 != null) {
    document.querySelector('.lujo-que-mereces .m-section__header .m-section__tabs').remove();
    insertarRayaEnTitulos1.innerHTML = '<div class="line"></div><span class="text">' + insertarRayaEnTitulos1.innerHTML + '</span>';
  }
  const insertarRayaEnTitulos2 = document.querySelectorAll('.line-title .m-section__header h2');
  if (insertarRayaEnTitulos2 != null) {
    insertarRayaEnTitulos2.forEach((title) => {
      console.log(title.innerHTML)
      title.innerHTML = '<div class="line"></div><span class="text">' + title.innerHTML + '</span>';
    });
  }
  const quitarTagImgAspectRatio = document.querySelectorAll('.banner-dual-40-60 responsive-image.m-image');
  if (quitarTagImgAspectRatio != null) {
    quitarTagImgAspectRatio.forEach((element) => {
      element.removeAttribute('style');
    });
  }
  const ajustarCopyright = document.querySelector('body.data-browser-cel .footer .copyright');
  if (ajustarCopyright != null) {
    ajustarCopyright.innerHTML = ajustarCopyright.innerHTML.replace('TYRONA', '<br>TYRONA');
  }
  const asesorButton = document.querySelector('body.template-product .btn-asesor');
  if (asesorButton != null) {
    const phone = "+573105244260";
    const productUrl = window.location.href; // Use current product page URL
    const message = "Hola, estoy interesado en este producto:\n" + productUrl;
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
    asesorButton.setAttribute('href', whatsappUrl);
    asesorButton.setAttribute('target', '_blank');
    asesorButton.style.display = 'inline-block'; // Ensure button is visible
  }
  const ajustesBanners1 = document.querySelector('body.data-browser-pc .ajustesBanners1');
  if (ajustesBanners1 != null) {
    ajustesBanners1.querySelector('.m-section-py').classList.remove('container-full');
    ajustesBanners1.querySelector('.m-section-py').classList.remove('m-section-my');
    ajustesBanners1.querySelector('.m-section-py').classList.remove('m-custom-content__container');
    const itemsImg = ajustesBanners1.querySelectorAll('.m-section-py .m-custom-content__wrapper .m-custom-content__block');
    itemsImg.forEach((img) => {
      const ratio = img.clientWidth/img.clientHeight;
      img.querySelector('.m-custom-content__block-inner .m-scroll-trigger .m-image').style.aspectRatio = ratio; 
    });
  }
  const ajustesBanners2 = document.querySelector('body.data-browser-pc .ajustesBanners2');
  if (ajustesBanners2 != null) {
    ajustesBanners2.querySelector('.m-section-py').classList.remove('container-full');
    ajustesBanners2.querySelector('.m-section-py').classList.remove('m-section-my');
    ajustesBanners2.querySelector('.m-section-py').classList.remove('m-custom-content__container');
    const itemsImg = ajustesBanners2.querySelectorAll('.m-section-py .m-custom-content__wrapper .m-custom-content__block');
    itemsImg.forEach((img) => {
      const ratio = img.clientWidth/img.clientHeight;
      img.querySelector('.m-custom-content__block-inner .m-scroll-trigger .m-image').style.aspectRatio = ratio; 
    });
  }
  const ajustesBannersAll = document.querySelectorAll('body.data-browser-cel .ajustesBannersAll .m-section-py');
  if (ajustesBannersAll != null) {
    ajustesBannersAll.forEach((div) => {
       div.classList.remove('container-full');
    });
  }
  const menuLinks = document.querySelectorAll('ul.m-menu a.m-menu__link');
  if (menuLinks != null) {
    const currentUrl = window.location.pathname;
    menuLinks.forEach(link => {
      if (link.getAttribute('href') === currentUrl) {
        // Añadir la clase "currentMenu" al elemento padre del enlace
        link.classList.add('currentMenu');
      }
    });
  }


  
}//ready
document.addEventListener("DOMContentLoaded", ready);


document.addEventListener('DOMContentLoaded', function () {
  const icon1 = 'https://cdn.shopify.com/s/files/1/0658/4018/5508/files/lines-plus-svgrepo-com.svg?v=1732401089'; // Características
  const icon2 = 'https://cdn.shopify.com/s/files/1/0658/4018/5508/files/warranty-term-svgrepo-com.svg?v=1732401089'; // Garantía
  const icon3 = 'https://cdn.shopify.com/s/files/1/0658/4018/5508/files/file-document-svgrepo-com.svg?v=1732401090'; // Términos
  const icon4 = 'https://cdn.shopify.com/s/files/1/0658/4018/5508/files/support-svgrepo-com.svg?v=1732401089'; // Servicio al Cliente
  const icon5 = 'https://cdn.shopify.com/s/files/1/0658/4018/5508/files/delivery-fast-svgrepo-com.svg?v=1732401089'; // Envíos

  const sections = [
    { text: 'Características', icon: icon1 },
    { text: 'Garantía', icon: icon2 },
    { text: 'Términos y Condiciones', icon: icon3 },
    { text: 'Servicio al Cliente', icon: icon4 },
    { text: 'Envíos', icon: icon5 }
  ];

  sections.forEach((section) => {
    const buttons = document.querySelectorAll('.m-collapsible--button span');
    buttons.forEach((button) => {
      if (button.textContent.trim() === section.text) {
        const img = document.createElement('img');
        img.src = section.icon;
        img.alt = section.text;
        img.style.width = '22px';
        img.style.height = '22px';
        img.style.marginRight = '8px';
        img.style.marginTop = '0px';
        button.insertAdjacentElement('afterbegin', img);
      }
    });
  });
});









